/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Target_PlaceholderInputs */

const en_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a target folder...`)
};

const fr_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un dossier cible...`)
};

const de_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Zielordner aus...`)
};

const it_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una cartella di destinazione...`)
};

const ru_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите целевую папку...`)
};

const es_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una carpeta de destino...`)
};

const zh_cn2_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择目标文件夹……`)
};

const ja_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象フォルダを選択してください...`)
};

const hi_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य फ़ोल्डर चुनें...`)
};

const pt_pt2_audio_embed_export_target_placeholder = /** @type {(inputs: Audio_Embed_Export_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma pasta de destino...`)
};

/**
* | output |
* | --- |
* | "Choose a target folder..." |
*
* @param {Audio_Embed_Export_Target_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_target_placeholder = /** @type {((inputs?: Audio_Embed_Export_Target_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Target_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_target_placeholder(inputs)
	if (locale === "de") return de_audio_embed_export_target_placeholder(inputs)
	if (locale === "it") return it_audio_embed_export_target_placeholder(inputs)
	if (locale === "ru") return ru_audio_embed_export_target_placeholder(inputs)
	if (locale === "es") return es_audio_embed_export_target_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_target_placeholder(inputs)
	if (locale === "ja") return ja_audio_embed_export_target_placeholder(inputs)
	if (locale === "hi") return hi_audio_embed_export_target_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_target_placeholder(inputs)
	return en_audio_embed_export_target_placeholder(inputs)
});